import { createSlice } from "@reduxjs/toolkit";

const SignatureSlice = createSlice({
  name: "signatures",
  initialState: {
    loading: false,
    error: null,
    signatures: {
      data: [],   // list of signatures
      total: 0,   // total count
    },
  },
  reducers: {
    // --- ADD SIGNATURE ---
    addSignatureStart(state) {
      state.loading = true;
      state.error = null;
    },
    addSignatureSuccess(state, action) {
      state.loading = false;
      state.signatures.data.push(action.payload);
      state.signatures.total += 1;
    },
    addSignatureFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

   // --- GET ALL SIGNATURES ---
    getSignaturesStart(state) {
      state.loading = true;
      state.error = null;
    },
    getSignaturesSuccess(state, action) {
      state.loading = false;
      state.signatures.data = action.payload.data || [];
      state.signatures.total = action.payload.total || 0;
    },
    getSignaturesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    clearSignatureError(state) {
      state.error = null;
    },
    //update slice
      updateSignatureStart(state) {
      state.loading = true;
      state.error = null;
    },
    updateSignatureSuccess(state, action) {
      state.loading = false;
       const updated = action.payload;
      const index = state.signatures.data.findIndex(
        (sig) => sig.uiid === updated.uiid
      );
      if (index !== -1) {
        state.signatures.data[index] = updated;
      }
    },
    updateSignatureFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  addSignatureStart,
  addSignatureSuccess,
  addSignatureFailure, 
  getSignaturesStart,
    getSignaturesSuccess,
    getSignaturesFailure,
  clearSignatureError,
  updateSignatureStart,
  updateSignatureSuccess,
  updateSignatureFailure,
} = SignatureSlice.actions;
export default SignatureSlice.reducer;
